
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sustainability-elchemy",
      function () {
        return require("private-next-pages/sustainability-elchemy/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sustainability-elchemy"])
      });
    }
  